(ns manage.adset-decision-tree-page.variants-rotation-ocp.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/material/Typography$default" :as Typography]
            [clojure.string :as str]
            [common.ocp.view :refer [defocp ocp]]
            [common.widgets.form-field :refer [form-field]]
            [manage.adset-decision-tree-page.event :as event]
            [manage.adset-decision-tree-page.rotation :as rotation]
            [manage.adset-decision-tree-page.sub :as sub]
            [manage.adset-decision-tree-page.view.side-panel.ad-variants
             :refer [ad-variant-section]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- parse-weight [value]
  (let [n (parse-long value)]
    (when (and n (pos? n)) n)))

(defui path-ad-variants [props]
  (let [parent-id (:parent-id props)]
    (when-not (use-subscribe [::sub/rotation-any-path-connected? parent-id])
      ($ ad-variant-section props))))

(defocp ocp-view ::ocp
  {:width "min(480px, 100%)"}
  [{:keys [outcome-node-id]}]
  (let [{:keys [label config parent-id]} (use-subscribe [::sub/node-data outcome-node-id])
        parent (use-subscribe [::sub/node-data parent-id])
        path-count (count (:outcome-node-ids parent))
        weight (rotation/path-display-weight parent config path-count)
        [name set-name] (uix/use-state (or label ""))
        [weight-input set-weight-input] (uix/use-state (str (or weight "")))
        trimmed-name (str/trim name)
        parsed-weight (parse-weight weight-input)
        can-apply? (and (not (str/blank? trimmed-name)) (some? parsed-weight))]
    (uix/use-effect
     (fn []
       (set-name (or label ""))
       (set-weight-input (str (or weight ""))))
     [label weight])
    ($ ocp
       {:title (or label "Path")
        :header ($ Typography {:variant "body2"
                               :color "text.secondary"
                               :sx #js {:px 3 :pb 2 :backgroundColor "grey.90"}}
                   "Configure this rotation path")
        :footer ($ Stack {:direction "row" :justifyContent "flex-end" :gap 1}
                   ($ Button {:variant "text"
                              :sx #js {:color "text.primary"}
                              :onClick #(rf/dispatch [:ocp/close])}
                      "Cancel")
                   ($ Button {:variant "contained"
                              :type "submit"
                              :disabled (not can-apply?)}
                      "Apply"))
        :on-submit (fn []
                     (when can-apply?
                       (rf/dispatch [::event/be-patch-node
                                     outcome-node-id
                                     {:label trimmed-name
                                      :config (assoc-in (or config {})
                                                        [:rotation :weight]
                                                        parsed-weight)}
                                     #(rf/dispatch [:ocp/close])])))}
       ($ Stack {:gap 3}
          ($ form-field {:label "Path name"}
             ($ TextField {:value name
                           :fullWidth true
                           :onChange #(set-name (.. % -target -value))}))
          ($ Stack {:gap 1}
             ($ Typography {:fontWeight 600 :color "text.subtle"} "Weight")
             ($ Typography {:variant "body2" :color "text.secondary"}
                "Assign the weight this path should receive.")
             ($ TextField {:value weight-input
                           :fullWidth true
                           :onChange #(set-weight-input (.. % -target -value))}))
          ($ path-ad-variants {:outcome-node-id outcome-node-id
                               :parent-id parent-id
                               :selected-item {:type :selection/outcome-node
                                               :decision-node-id parent-id
                                               :outcome-node-id outcome-node-id}
                               :variant-properties {:empty-text "No ad variants yet"}})))))
